import axios from 'axios';
import { CUSTOMER_SERVICE_IMPORT } from 'api/constants';

/**
 * post file as a formdata to mokapos-*.s3.amazonaws.com/
 * @param formdata
 * @returns {Promise.<T>|*|Promise<R>} JSON object from server, or Error object if fails.
 */
export function uploadToS3(url, formData) {
  const config = { headers: { 'Content-Type': 'multipart/form-data' } };
  return axios.post(url, formData, config).catch(error => {
    return Promise.reject(new Error(error));
  });
}

export function customerServiceImport(payload) {
  return axios
    .post(CUSTOMER_SERVICE_IMPORT(), payload, { withCredentials: true })
    .catch(error => {
      const { response } = error;
      return Promise.reject(response);
    });
}
